import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Typography, MenuItem, Select, Grid2, Modal, IconButton, Paper, Box, Switch, TextField, Alert, Snackbar, InputLabel, InputAdornment } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Grid,
    FormControl,
} from '@mui/material';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import PhoneInput from 'react-phone-number-input';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TokenError from '../tokenError';
import { makeGetRequestToUrl } from '../commonFunc.jsx';
import config from '../../config/config.js';
import { styled } from '@mui/material/styles';
import editIcon from '../../assets/icons/edit.svg';
var constants = require('../../constant');

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const Fleets = () => {
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();

    const cities = JSON.parse(localStorage.getItem('cities'));
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [openAddFleet, setOpenAddFleet] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];

    const [fleetId, setFleetId] = useState('');
    const [fleetName, setFleetName] = useState('');
    const [city, setCity] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [email, setEmail] = useState('');
    const [payoutDestination, setPayoutDestination] = useState('');
    const [isActive, setIsActive] = useState(true);
    const operationsUrl = config.operationsUrl;
    const clientId = localStorage.getItem('clientId');
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [detailsLoading, setDetailsLoading] = useState(false);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [requiredDocuments, setRequiredDocuments] = useState([]);
    const [documentsLoading, setDocumentsLoading] = useState(false);

    const [fleetDocuments, setFleetDocuments] = useState({});
    const [documentUploading, setDocumentUploading] = useState({});
    const [docActionLoading, setDocActionLoading] = useState({});
    const token = localStorage.getItem('token')

    const paymentMethodConst = [
        { "payment_id": "1", "payment_name": "Razorpay" },
        { "payment_id": "2", "payment_name": "Stripe" },
    ]

    useEffect(() => {
        if (!openAddFleet) {
            const loadDocuments = async () => {
                const data = await fetchFleetData();
                setRows(data); // Set rows with fetched data
            };
            loadDocuments();
        }

    }, [openAddFleet, cityFilter]);

    const handleFleetDocumentImageChange = async (event, documentId, maxImages) => {
        const files = Array.from(event.target.files || []);

        if (!files.length) return;

        if (files.length > maxImages) {
            setMessage(`You can upload maximum ${maxImages} image(s) for this document.`);
            showSnackbar(true);
            return;
        }

        try {
            setDocumentUploading((prev) => ({
                ...prev,
                [documentId]: true,
            }));

            const uploadedImages = [];

            for (const file of files) {
                const formData = new FormData();
                formData.append('image', file);

                const url = operationsUrl + '/upload_image';

                const response = await axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                if (response?.data?.url) {
                    uploadedImages.push(response.data.url);
                }
            }

            setFleetDocuments((prev) => ({
                ...prev,
                [documentId]: {
                    ...(prev[documentId] || {}),
                    images: uploadedImages,
                },
            }));
        } catch (error) {
            console.error('Error uploading fleet document:', error);

            setMessage(
                error?.response?.data?.message ||
                error?.message ||
                'Error uploading document image.'
            );

            showSnackbar(true);
        } finally {
            setDocumentUploading((prev) => ({
                ...prev,
                [documentId]: false,
            }));
        }
    };

    const handleFleetDocumentFieldChange = (documentId, field, value) => {
        setFleetDocuments((prev) => ({
            ...prev,
            [documentId]: {
                ...(prev[documentId] || {}),
                [field]: value,
            },
        }));
    };

    // useEffect(()=>{
    //     fetchFleetData();
    // },[cityFilter])

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'status') setStatusFilter(value);

        setIsFilterApplied(
            Boolean(value) || Boolean(statusFilter) || Boolean(cityFilter)
        );
    };

    const applyOrResetFilter = () => {
        if (isFilterApplied) {
            setStatusFilter('');
            setCityFilter('');
            setIsFilterApplied(false);
            const resetDocuments = async () => {
                const data = await fetchFleetData();
                setRows(data);
            };
            resetDocuments();
        } else {
            const filteredRows = rows.filter((document) =>
                (statusFilter ? document.status === statusFilter : true) &&
                (cityFilter ? document.city === cityFilter : true)
            );
            setRows(filteredRows);
        }
    };

    // Ensure rows is an array and calculate the number of pages safely
    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const currentPage = Math.min(page, totalPages - 1); // Avoid invalid page numbers

    const handleOpenAddFleet = () => {
        setEditMode(false); // Set to "Add" mode
        setSelectedDocument(null); // No pre-filled data
        setOpenAddFleet(true);
        setRequiredDocuments([]);
    };

    const handleCloseAddFleet = () => {
        resetFormFields();
        setOpenAddFleet(false);
    };

    const fetchRequiredDocuments = async (cityId) => {
        if (!cityId) {
            setRequiredDocuments([]);
            return;
        }

        try {
            setDocumentsLoading(true);

            const token = localStorage.getItem('token');

            const url = `${serverUrl}/fleet/get_required_documents`;

            const response = await makeGetRequestToUrl(url, {
                city_id: cityId,
                token: token,
            });

            if (response?.flag === 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);

                return;
            }

            if (response?.flag === 200) {
                setRequiredDocuments(response.data || []);
            } else {
                setRequiredDocuments([]);
                setMessage(
                    response?.message || 'Unable to fetch required documents'
                );
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error fetching required documents:', error);

            setRequiredDocuments([]);

            setMessage(
                error?.response?.data?.message ||
                error?.message ||
                'Something went wrong while fetching required documents'
            );

            showSnackbar(true);
        } finally {
            setDocumentsLoading(false);
        }
    };

    const fetchFleetData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/fleet/fetch_all`;
            const obj = {
                token: token, timestamp: timestamp, city_id: cityFilter
            }

            const response = await makeGetRequestToUrl(url, obj);

            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            return response.data || [];
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Function for document details
    const handleViewDetails = async (row) => {
        const token = localStorage.getItem('token');

        const payload = {
            fleet_id: row.fleet_id,
            token: token,
        };

        setDetailsLoading(true);

        try {
            const url = `${serverUrl}/fleet/get_details`;

            const response = await makeGetRequestToUrl(url, payload);

            console.log('Fleet details response:', response.data);

            if (response.data?.flag === 102) {
                localStorage.removeItem('token');

                setErrorMessage(
                    'Your session has expired. Please log in again.'
                );

                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);

                return;
            }

            if (response?.flag === 200) {
                const fleetData = response.data;

                setSelectedDocument({
                    fleet: fleetData?.fleet || {},
                    documents: fleetData?.documents || [],
                });

                setDetailsOpen(true);
            } else {
                setMessage(
                    response.data?.message ||
                    'Unable to fetch fleet details'
                );

                showSnackbar(true);
            }
        } catch (error) {
            console.error(
                'Error while fetching fleet details:',
                error
            );

            setMessage(
                error?.response?.data?.message ||
                error?.message ||
                'Something went wrong while fetching fleet details'
            );

            showSnackbar(true);
        } finally {
            setDetailsLoading(false);
        }
    };

    const handleCloseDetails = () => {
        setDetailsOpen(false);
        setSelectedDocument(null);
    };

    // Reload the table rows without touching anything else
    const refreshRows = async () => {
        const data = await fetchFleetData();
        if (Array.isArray(data)) setRows(data);
    };

    // Reload the open sidebar silently (no "Loading fleet details..." flash)
    const refreshFleetDetails = async (fleetId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await makeGetRequestToUrl(`${serverUrl}/fleet/get_details`, {
                fleet_id: fleetId,
                token,
                timestamp: new Date().getTime(), // avoid cached responses
            });

            if (response?.flag === 200) {
                setSelectedDocument({
                    fleet: response.data?.fleet || {},
                    documents: response.data?.documents || [],
                });
            }
        } catch (error) {
            console.error('Error refreshing fleet details:', error);
        }
    };

    const handleApproveReject = async (status, fleetId, documentId = null) => {
        const token = localStorage.getItem('token');
        const isDocAction = documentId !== null && documentId !== undefined;
        const loadingKey = `${documentId}-${status}`;

        const payload = {
            fleet_id: fleetId,
            status: status,
            token: token,
        };

        if (isDocAction) {
            payload.document_id = documentId;
        }

        try {
            if (isDocAction) {
                setDocActionLoading((prev) => ({ ...prev, [loadingKey]: true }));
            }

            const url = operationsUrl + '/panel/approve_reject_fleet';
            const response = await axios.post(url, payload);

            if (response.data?.flag === 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => navigate('/signup'), 2000);
                return;
            }

            if (response.data?.flag === 200) {
                const approved = status === 1;

                setMessage(
                    response.data?.message ||
                    (isDocAction
                        ? `Document ${approved ? 'approved' : 'rejected'} successfully`
                        : `Fleet ${approved ? 'approved' : 'rejected'} successfully`)
                );
                showSnackbar(true);

                // Re-fetch both the table and the sidebar from the server,
                // so fleet status, document status and reason are all current
                await Promise.all([
                    refreshRows(),
                    refreshFleetDetails(fleetId),
                ]);
                handleCloseDetails();

                return;
            }

            setMessage(response.data?.message || 'Unable to update status');
            showSnackbar(true);
        } catch (error) {
            console.error('Error while approving/rejecting:', error);
            setMessage(
                error?.response?.data?.message ||
                error?.message ||
                'Something went wrong'
            );
            showSnackbar(true);
        } finally {
            if (isDocAction) {
                setDocActionLoading((prev) => ({ ...prev, [loadingKey]: false }));
            }
        }
    };


    // Populate form fields in edit mode
    useEffect(() => {
        if (editMode && selectedDocument) {
            // const payment = selectedDocument.bank_details.payment_method;
            const payment = paymentMethodConst.find(payment => payment.payment_id == selectedDocument.bank_details.payment_method);
            const paymentName = payment ? payment.payment_name : '--';

            setFleetId(selectedDocument.fleet_id || '');
            setFleetName(selectedDocument.name || '');
            setCity(selectedDocument.city_id.city_name || '');
            setMobileNumber(selectedDocument.phone_no || '');
            setEmail(selectedDocument.email || '');
            setIsActive(selectedDocument.status === 1);
        } else {
            // Reset fields in add mode
            resetFormFields();
        }
    }, [editMode, selectedDocument]);

    // Function to reset form fields
    const resetFormFields = () => {
        setFleetId('');
        setFleetName('');
        setCity('');
        setMobileNumber('');
        setEmail('');
        setIsActive(true);
        setRequiredDocuments([]);
        setPayoutDestination('');
    };

    // Function to handle saving the document
const handleSubmit = async () => {
const documentsPayload = requiredDocuments
    .map((document) => {
        const documentData = fleetDocuments[document.document_id] || {};

        if (
            (!documentData.images || documentData.images.length === 0) &&
            !documentData.document_number &&
            !documentData.expiry_date
        ) {
            return null;
        }

        return {
            document_id: document.document_id,
            document_number: documentData.document_number || '',
            images: documentData.images?.[0] || '',
            expiry_date: documentData.expiry_date || '',
        };
    })
    .filter(Boolean);

    const payload = {
        name: fleetName,
        city_id:
            clientCities.find(
                (cityObj) => cityObj.city_name === city
            )?.city_id || null,
        phone_no: mobileNumber,
        email: email,
        token,
        payout_destination: payoutDestination,
        documents: documentsPayload,
    };

    // Include fleet_id in edit mode
    if (editMode && fleetId) {
        payload.fleet_id = fleetId;
    }

    try {
        const url = operationsUrl + '/panel/add_fleet';

        const response = await axios.post(url, payload);

        if (response.data.flag === 102) {
            localStorage.removeItem('token');

            setErrorMessage(
                'Your session has expired. Please log in again.'
            );

            setTokenExpired(true);

            setTimeout(() => {
                navigate('/signup');
            }, 2000);

            return;
        }

        if (response.data.flag === 200) {
            setMessage(response.data.message);
            showSnackbar(true);
        } else {
            setMessage(response.data.message);
            showSnackbar(true);
        }
    } catch (error) {
        console.error('Error while saving fleet:', error);

        setMessage(
            error?.response?.data?.message ||
            error?.message ||
            'Something went wrong while saving fleet'
        );

        showSnackbar(true);
    }

    handleCloseAddFleet();
    fetchFleetData();
};

    // Reset the form fields
    const handleReset = () => {
        resetFormFields();
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        showSnackbar(false);
    };
    return (
        <div>
            {tokenExpired && (<TokenError />)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Fleets
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '2%' }}>
                {/* Filter controls */}
                <Grid2 item>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Select
                        value={statusFilter}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Status</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                </Grid2>
                <Grid2 item style={{ marginLeft: '4%' }}>
                    <Button
                        variant="contained"
                        onClick={applyOrResetFilter}
                        style={{
                            width: '185px',
                            height: '50px',
                            marginRight: '1px',
                            backgroundColor: isFilterApplied ? '#F5BB19' : '#0065FF',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        {isFilterApplied ? 'Reset Filter' : 'Apply Filter'}
                    </Button>
                </Grid2>
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddFleet}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Fleet
                    </Button>
                </Grid2>
            </Grid2>

            {/* Sidebar for AddDocument */}
            <div
                style={{
                    position: 'fixed',
                    top: 65,
                    right: openAddFleet ? 0 : '-100%',
                    height: '100%',
                    width: '50%',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: 20
                }}
            >
                <Box onClose={handleCloseAddFleet} editMode={editMode}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        {/* Close Button Outside the Card */}
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseAddFleet}
                            style={{
                                position: 'absolute',
                                top: '-15px', // Position it above the Paper component
                                left: '1px',
                                color: '#333',
                                zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Paper elevation={3}
                            style={{
                                padding: '30px', maxWidth: '800px', margin: '0 auto',
                                backgroundColor: '#FFFFFF', borderRadius: '12px'
                            }}>
                            <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                {editMode ? 'Edit Fleet' : 'Add Fleet'}
                            </Typography>

                            {editMode && (
                                <div style={{
                                    display: 'flex', alignItems: 'center', backgroundColor: '#fff', padding: '10px 20px',
                                    border: '1px solid #E0E0E0', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                    marginBottom: '20px', marginTop: '50px'
                                }}>
                                    <Typography variant="body1" style={{ color: '#4A4A4A' }}>
                                        Fleet
                                    </Typography>
                                    <div style={{ display: 'flex', marginLeft: 'auto' }}>
                                        <Button variant="contained"
                                            onClick={() => setIsActive(true)} // Fixed: Use setIsActive
                                            style={{
                                                backgroundColor: isActive ? '#0DBA78' : '#F4F4F4',
                                                color: isActive ? '#FFFFFF' : '#9E9E9E',
                                                textTransform: 'none', borderRadius: '8px 0 0 8px',
                                                boxShadow: 'none', padding: '6px 16px', minWidth: '80px'
                                            }}>
                                            Enable
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => setIsActive(false)} // Fixed: Use setIsActive
                                            style={{
                                                backgroundColor: !isActive ? '#D14545' : '#F4F4F4', // Fixed: Use isActive
                                                color: !isActive ? '#FFFFFF' : '#9E9E9E', textTransform: 'none',
                                                borderRadius: '0 8px 8px 0', // Rounded on the right side
                                                boxShadow: 'none', padding: '6px 16px', minWidth: '80px'
                                            }}>
                                            Disable
                                        </Button>
                                    </div>
                                </div>
                            )}

                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Fleet Name <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Fleet Name"
                                        fullWidth
                                        variant="outlined"
                                        value={fleetName}
                                        onChange={(e) => setFleetName(e.target.value)}
                                        InputProps={{
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#E0E0E0',
                                            },
                                            '& .MuiInputLabel-root': {
                                                fontSize: '16px',
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>City <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Select City"
                                        select
                                        fullWidth
                                        variant="outlined"
                                        value={city}
                                        onChange={(e) => {
                                            const selectedCityName = e.target.value;

                                            setCity(selectedCityName);

                                            const selectedCity = clientCities.find(
                                                (cityObj) => cityObj.city_name === selectedCityName
                                            );

                                            if (selectedCity?.city_id) {
                                                fetchRequiredDocuments(selectedCity.city_id);
                                            } else {
                                                setRequiredDocuments([]);
                                            }
                                        }}
                                    >
                                        {clientCities.map((cityObj) => (
                                            <MenuItem key={cityObj.city_id} value={cityObj.city_name}>
                                                {cityObj.city_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Box sx={{
                                        '& .PhoneInputInput': {
                                            border: 'none',
                                            outline: 'none',
                                        }
                                    }}>
                                        <PhoneInput
                                            defaultCountry="IN"
                                            style={{
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                                border: '1px solid #E0E0E0',
                                                borderRadius: '4px',
                                                width: '100%',
                                                boxSizing: 'border-box'
                                            }}
                                            placeholder="Enter phone number"
                                            value={mobileNumber}
                                            onChange={setMobileNumber}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span> Email <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Email"
                                        fullWidth
                                        variant="outlined"
                                        type="text"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {
                                                height: '56px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#E0E0E0',
                                            },
                                            '& .MuiInputLabel-root': {
                                                fontSize: '16px',
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <InputLabel
                                            sx={{
                                                fontSize: '16px',
                                            }}
                                        >
                                            Payout Destination <span style={{ color: 'red' }}>*</span>
                                        </InputLabel>

                                        <Select
                                            value={payoutDestination}
                                            onChange={(e) => setPayoutDestination(e.target.value)}
                                            label="Payout Destination *"
                                            sx={{
                                                height: '56px',
                                                fontSize: '16px',
                                                backgroundColor: '#FFFFFF',

                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#E0E0E0',
                                                },

                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#E0E0E0',
                                                },

                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#E0E0E0',
                                                },
                                            }}
                                        >
                                            <MenuItem value={1}>Fleet</MenuItem>
                                            <MenuItem value={2}>Driver</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box
                                        sx={{
                                            marginTop: '10px',
                                            padding: '20px',
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontSize: '18px',
                                                fontWeight: 600,
                                                marginBottom: '15px',
                                            }}
                                        >
                                            Required Documents
                                        </Typography>

                                        {documentsLoading ? (
                                            <Typography sx={{ color: '#777', fontSize: '14px' }}>
                                                Loading required documents...
                                            </Typography>
                                        ) : requiredDocuments.length === 0 ? (
                                            <Typography sx={{ color: '#777', fontSize: '14px' }}>
                                                {city
                                                    ? 'No required documents configured for this city.'
                                                    : 'Select a city to view required documents.'}
                                            </Typography>
                                        ) : (
                                            requiredDocuments?.map((document) => {
                                                const documentData = fleetDocuments[document.document_id] || {};
                                                const images = documentData.images || [];
                                                const isUploading = documentUploading[document.document_id];

                                                return (
                                                    <Box
                                                        key={document.document_id}
                                                        sx={{
                                                            padding: '18px',
                                                            marginBottom: '15px',
                                                            border: '1px solid #E0E0E0',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#FAFAFA',
                                                        }}
                                                    >
                                                        {/* Document Name */}
                                                        <Typography
                                                            sx={{
                                                                fontSize: '16px',
                                                                fontWeight: 600,
                                                                marginBottom: '5px',
                                                            }}
                                                        >
                                                            {document.document_name}

                                                            {document.is_required === 1 && (
                                                                <span style={{ color: 'red' }}> *</span>
                                                            )}
                                                        </Typography>

                                                        <Typography
                                                            sx={{
                                                                fontSize: '12px',
                                                                color: '#777',
                                                                marginBottom: '15px',
                                                            }}
                                                        >
                                                            Upload {document.no_of_images} image
                                                            {document.no_of_images > 1 ? 's' : ''}

                                                            {document.is_doc_number_required === 1 &&
                                                                ' • Document number required'}

                                                            {document.is_doc_expired === 1 &&
                                                                ' • Expiry date required'}
                                                        </Typography>

                                                        {/* Document Number */}
                                                        {document.is_doc_number_required === 1 && (
                                                            <TextField
                                                                fullWidth
                                                                label="Document Number"
                                                                placeholder="Enter document number"
                                                                value={documentData.document_number || ''}
                                                                onChange={(e) =>
                                                                    handleFleetDocumentFieldChange(
                                                                        document.document_id,
                                                                        'document_number',
                                                                        e.target.value
                                                                    )
                                                                }
                                                                sx={{
                                                                    marginBottom: '15px',
                                                                    backgroundColor: '#FFFFFF',
                                                                }}
                                                            />
                                                        )}

                                                        {/* Expiry Date */}
                                                        {document.is_doc_expired === 1 && (
                                                            <TextField
                                                                fullWidth
                                                                type="date"
                                                                label="Expiry Date"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                value={documentData.expiry_date || ''}
                                                                onChange={(e) =>
                                                                    handleFleetDocumentFieldChange(
                                                                        document.document_id,
                                                                        'expiry_date',
                                                                        e.target.value
                                                                    )
                                                                }
                                                                sx={{
                                                                    marginBottom: '15px',
                                                                    backgroundColor: '#FFFFFF',
                                                                }}
                                                            />
                                                        )}

                                                        {/* Upload Images */}
                                                        <Typography
                                                            sx={{
                                                                fontSize: '14px',
                                                                fontWeight: 500,
                                                                marginBottom: '8px',
                                                            }}
                                                        >
                                                            Document Images
                                                        </Typography>

                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            multiple={document.no_of_images > 1}
                                                            onChange={(e) =>
                                                                handleFleetDocumentImageChange(
                                                                    e,
                                                                    document.document_id,
                                                                    document.no_of_images
                                                                )
                                                            }
                                                            style={{
                                                                marginBottom: '12px',
                                                            }}
                                                        />

                                                        {/* Uploading */}
                                                        {isUploading && (
                                                            <Typography
                                                                sx={{
                                                                    fontSize: '13px',
                                                                    color: '#0065FF',
                                                                    marginBottom: '10px',
                                                                }}
                                                            >
                                                                Uploading image(s)...
                                                            </Typography>
                                                        )}

                                                        {/* Uploaded Images */}
                                                        {images.length > 0 && (
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    gap: '10px',
                                                                    flexWrap: 'wrap',
                                                                    marginTop: '10px',
                                                                }}
                                                            >
                                                                {images.map((imageUrl, index) => (
                                                                    <Box
                                                                        key={index}
                                                                        sx={{
                                                                            position: 'relative',
                                                                            border: '1px solid #D1D5DB',
                                                                            borderRadius: '8px',
                                                                            padding: '4px',
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={imageUrl}
                                                                            alt={`${document.document_name}-${index + 1}`}
                                                                            style={{
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                objectFit: 'cover',
                                                                                borderRadius: '6px',
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                ))}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                );
                                            })
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#0065FF',
                                        color: 'white',
                                    }}
                                >
                                    {editMode ? 'Update' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleReset}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#F0F0F0',
                                        color: '#B0B0B0',
                                    }}
                                >
                                    Reset
                                </Button>
                            </div>
                        </Paper>

                    </div>
                </Box>
            </div>

            {/* Documents Table */}
            <TableContainer className="table-container" sx={{ maxHeight: '70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                <TableSortLabel
                                    active={orderBy === 'fleet_id'}
                                    direction={orderBy === 'fleet_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('fleet_id')}
                                >
                                    ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fleet Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Phone Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Email</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>City</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Wallet Balance</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Payout Destination</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .filter((row) => {
                                const isStatusMatch = statusFilter
                                    ? (statusFilter === 'Active' ? row.status === 1 : row.status === 0)
                                    : true;
                                const isCityMatch = cityFilter ? row.city_id === cityFilter : true;

                                return isStatusMatch && isCityMatch;
                            })
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {
                                const city = clientCities.find(city => city.city_id === row.city_id);
                                const cityName = city ? city.city_name : '---';

                                const payment = paymentMethodConst.find(payment => payment.payment_id == row.bank_details?.payment_method);
                                const paymentName = payment ? payment.payment_name : '--';
                                return (
                                    <TableRow key={row.fleet_id}>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fleet_id}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.name}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.phone_no}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.email}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{cityName}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.status === 1 ? '#0DBA78' : '#D14545', fontWeight: '500' }}>{row.status == 1 ? 'Apporved' : row.status == 2 ? 'Rejected' : 'Pending'}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.wallet_balance}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.payout_destination == 1 ? 'Fleet' : row.payout_destination == 2 ? 'Driver' : '--'}</Typography></TableCell>
                                        <TableCell align="center">
                                            <Button
                                                variant="contained"
                                                onClick={() => handleViewDetails(row)}
                                                sx={{
                                                    backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                    borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "120px",
                                                    '&:hover': { backgroundColor: '#0DBA78', color: 'white' },
                                                    '&:active': { backgroundColor: '#0DBA78', color: 'white' }
                                                }}>

                                                <Typography sx={{ marginRight: '6%' }}>ViewDetails</Typography>
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                    </TableBody>
                </Table>

                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            {/* <Alert severity="error" sx={{width:'40%', marginLeft:'auto'}}>{message}</Alert> */}
            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            {/* =========================================================
    FLEET DETAILS SIDEBAR
========================================================= */}

            <div
                style={{
                    position: 'fixed',
                    top: 65,
                    right: detailsOpen ? 0 : '-100%',
                    height: 'calc(100vh - 65px)',
                    width: '50%',
                    minWidth: '500px',
                    backgroundColor: '#F9F9F9',
                    boxShadow: '-5px 0px 20px rgba(0,0,0,0.12)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1200,
                    overflowY: 'auto',
                    padding: '18px 24px',
                }}
            >
                {/* Header */}

                <Box
                    sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        backgroundColor: '#FFFFFF',
                        borderBottom: '1px solid #E5E7EB',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '18px 24px',
                        borderRadius: '10px',
                        marginBottom: '20px'

                    }}
                >
                    <Box>
                        <Typography
                            sx={{
                                fontSize: '22px',
                                fontWeight: 600,
                            }}
                        >
                            Fleet Details
                        </Typography>

                        {selectedDocument?.fleet?.fleet_id && (
                            <Typography
                                sx={{
                                    fontSize: '13px',
                                    color: '#777',
                                    marginTop: '4px',
                                }}
                            >
                                Fleet ID: {selectedDocument.fleet.fleet_id}
                            </Typography>
                        )}
                    </Box>

                    <IconButton
                        onClick={handleCloseDetails}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Loading */}

                {detailsLoading && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '300px',
                        }}
                    >
                        <Typography>
                            Loading fleet details...
                        </Typography>
                    </Box>
                )}

                {/* Details */}

                {!detailsLoading && selectedDocument?.fleet && (
                    <Box sx={{ padding: '24px' }}>

                        {/* =================================================
                FLEET INFORMATION
            ================================================= */}

                        <Paper
                            elevation={0}
                            sx={{
                                padding: '22px',
                                borderRadius: '10px',
                                border: '1px solid #E0E0E0',
                                marginBottom: '20px',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    marginBottom: '20px',
                                }}
                            >
                                Fleet Information
                            </Typography>

                            <Grid container spacing={2.5}>

                                {/* Fleet Name */}

                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: '#777',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        Fleet Name
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '15px',
                                            fontWeight: 500,
                                        }}
                                    >
                                        {selectedDocument.fleet.name || '--'}
                                    </Typography>
                                </Grid>

                                {/* Fleet ID */}

                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: '#777',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        Fleet ID
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '15px',
                                            fontWeight: 500,
                                        }}
                                    >
                                        {selectedDocument.fleet.fleet_id || '--'}
                                    </Typography>
                                </Grid>

                                {/* Email */}

                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: '#777',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        Email
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '15px',
                                            fontWeight: 500,
                                            wordBreak: 'break-word',
                                        }}
                                    >
                                        {selectedDocument.fleet.email || '--'}
                                    </Typography>
                                </Grid>

                                {/* Phone */}

                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: '#777',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        Phone Number
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '15px',
                                            fontWeight: 500,
                                        }}
                                    >
                                        {selectedDocument.fleet.phone_no || '--'}
                                    </Typography>
                                </Grid>

                                {/* Client ID */}

                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: '#777',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        Client ID
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '15px',
                                            fontWeight: 500,
                                        }}
                                    >
                                        {selectedDocument.fleet.client_id || '--'}
                                    </Typography>
                                </Grid>

                                {/* City */}

                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: '#777',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        City ID
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '15px',
                                            fontWeight: 500,
                                        }}
                                    >
                                        {selectedDocument.fleet.city_id || '--'}
                                    </Typography>
                                </Grid>

                                {/* Created At */}

                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: '#777',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        Created At
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '14px',
                                        }}
                                    >
                                        {selectedDocument.fleet.created_at
                                            ? new Date(
                                                selectedDocument.fleet.created_at
                                            ).toLocaleString()
                                            : '--'}
                                    </Typography>
                                </Grid>

                                {/* Updated At */}

                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: '#777',
                                            marginBottom: '5px',
                                        }}
                                    >
                                        Updated At
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '14px',
                                        }}
                                    >
                                        {selectedDocument.fleet.updated_at
                                            ? new Date(
                                                selectedDocument.fleet.updated_at
                                            ).toLocaleString()
                                            : '--'}
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Paper>

                        {/* =================================================
                DOCUMENTS
            ================================================= */}

                        <Paper
                            elevation={0}
                            sx={{
                                padding: '22px',
                                borderRadius: '10px',
                                border: '1px solid #E0E0E0',
                                marginBottom: '20px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '20px',
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '18px',
                                        fontWeight: 600,
                                    }}
                                >
                                    Documents
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        color: '#777',
                                    }}
                                >
                                    {selectedDocument.documents?.length || 0}{' '}
                                    Documents
                                </Typography>
                            </Box>

                            {selectedDocument.documents?.length === 0 ? (
                                <Box
                                    sx={{
                                        padding: '30px',
                                        textAlign: 'center',
                                        backgroundColor: '#F8F8F8',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: '#777',
                                            fontSize: '14px',
                                        }}
                                    >
                                        No documents available
                                    </Typography>
                                </Box>
                            ) : (
                                selectedDocument.documents.map(
                                    (document, index) => (
                                        <Box
                                            key={
                                                document.document_id ||
                                                index
                                            }
                                            sx={{
                                                border: '1px solid #E0E0E0',
                                                borderRadius: '8px',
                                                padding: '16px',
                                                marginBottom: '12px',
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: '15px',
                                                    marginBottom: '12px',
                                                }}
                                            >
                                                {document.document_name ||
                                                    document.name ||
                                                    `Document ${index + 1}`}
                                            </Typography>

                                            <Grid container spacing={2}>

                                                {document.document_number && (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize: '12px',
                                                                color: '#777',
                                                            }}
                                                        >
                                                            Document Number
                                                        </Typography>

                                                        <Typography
                                                            sx={{
                                                                fontSize: '14px',
                                                            }}
                                                        >
                                                            {
                                                                document.document_number
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                )}

                                                {document.expiry_date && (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize: '12px',
                                                                color: '#777',
                                                            }}
                                                        >
                                                            Expiry Date
                                                        </Typography>

                                                        <Typography
                                                            sx={{
                                                                fontSize: '14px',
                                                            }}
                                                        >
                                                            {
                                                                document.expiry_date ? document.expiry_date.split('T')[0] : ''
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                )}
                                            </Grid>

                                            {/* Document Image */}
                                            {(() => {
                                                const raw =
                                                    typeof document.images === 'string'
                                                        ? document.images
                                                        : document.images?.url || document.images?.src || '';

                                                const imageList = raw
                                                    .split(';;;;')
                                                    .map((url) => url.trim())
                                                    .filter(Boolean);

                                                if (imageList.length === 0) return null;

                                                return (
                                                    <Box
                                                        sx={{
                                                            marginTop: '15px',
                                                            display: 'grid',
                                                            gap: '12px',
                                                            gridTemplateColumns:
                                                                imageList.length === 1 ? '1fr' : 'repeat(auto-fill, minmax(200px, 1fr))',
                                                        }}
                                                    >
                                                        {imageList.map((url, i) => (
                                                            <Box
                                                                key={i}
                                                                component="a"
                                                                href={url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{
                                                                    display: 'block',
                                                                    border: '1px solid #E0E0E0',
                                                                    borderRadius: '8px',
                                                                    overflow: 'hidden',
                                                                    backgroundColor: '#F5F5F5',
                                                                    position: 'relative',
                                                                }}
                                                            >
                                                                {imageList.length > 1 && (
                                                                    <Typography
                                                                        sx={{
                                                                            position: 'absolute',
                                                                            top: 6,
                                                                            left: 6,
                                                                            fontSize: '11px',
                                                                            color: '#fff',
                                                                            backgroundColor: 'rgba(0,0,0,0.6)',
                                                                            borderRadius: '4px',
                                                                            padding: '2px 6px',
                                                                        }}
                                                                    >
                                                                        {/* {imageList.length === 2 ? (i === 0 ? 'Front' : 'Back') : `Image ${i + 1}`} */}
                                                                    </Typography>
                                                                )}
                                                                <img
                                                                    src={url}
                                                                    alt={`${document.document_name || 'Fleet Document'} ${i + 1}`}
                                                                    style={{
                                                                        width: '100%',
                                                                        maxHeight: imageList.length === 1 ? '300px' : '220px',
                                                                        objectFit: 'contain',
                                                                        display: 'block',
                                                                    }}
                                                                />
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                );
                                            })()}
                                            {/* Per-document status + actions for ddocuments */}
                                            <Box
                                                sx={{
                                                    marginTop: '15px',
                                                    paddingTop: '14px',
                                                    borderTop: '1px solid #EEE',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    gap: 2,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color:
                                                            document.status === 1
                                                                ? '#0DBA78'
                                                                : document.status === 2
                                                                    ? '#D14545'
                                                                    : '#F5A623',
                                                    }}
                                                >
                                                    {document.status === 1
                                                        ? 'Approved'
                                                        : document.status === 3
                                                            ? 'Rejected'
                                                             : document.status === 0
                                                            ? 'Pending'
                                                            : ''}
                                                </Typography>

                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    {document.status !== 1 && (
                                                        <Button
                                                            variant="contained"
                                                            disableElevation
                                                            disabled={Boolean(docActionLoading[`${document.document_id}-1`])}
                                                            onClick={() =>
                                                                handleApproveReject(1, selectedDocument.fleet.fleet_id, document.document_id)
                                                            }
                                                            sx={{
                                                                minWidth: '90px',
                                                                height: '36px',
                                                                backgroundColor: '#0DBA78',
                                                                textTransform: 'none',
                                                                borderRadius: '8px',
                                                                '&:hover': { backgroundColor: '#0BA96C' },
                                                            }}
                                                        >
                                                            {docActionLoading[`${document.document_id}-1`] ? 'Approving…' : 'Approve'}
                                                        </Button>
                                                    )}

                                                    {document.status !== 1 && document.status !== 2 && (
                                                        <Button
                                                            variant="contained"
                                                            disableElevation
                                                            disabled={Boolean(docActionLoading[`${document.document_id}-2`])}
                                                            onClick={() =>
                                                                handleApproveReject(2, selectedDocument.fleet.fleet_id, document.document_id)
                                                            }
                                                            sx={{
                                                                minWidth: '90px',
                                                                height: '36px',
                                                                backgroundColor: '#D14545',
                                                                textTransform: 'none',
                                                                borderRadius: '8px',
                                                                '&:hover': { backgroundColor: '#C13C3C' },
                                                            }}
                                                        >
                                                            {docActionLoading[`${document.document_id}-2`] ? 'Rejecting…' : 'Reject'}
                                                        </Button>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>
                                    )
                                )
                            )}
                        </Paper>
                    </Box>
                )}
            </div>
        </div>
    );

};

export default Fleets